const login = (backendUrl: string): void => {
  window.location.href = `${backendUrl}/oauth2/authorization/auth`
}

export const NavigationUtils = {
  login,
}
